import React from 'react';
type PageType = 'home' | 'commercial' | 'services' | 'residential' | 'reservation' | 'cinema';
interface CommercialSolutionsProps {
  onNavigate: (page: PageType) => void;
}
const services = [{
  id: 'konferencni-technika',
  label: 'konferenční technika'
}, {
  id: 'audiovizualni-reseni',
  label: 'audiovizuální řešení'
}, {
  id: 'digital-signage',
  label: 'digital signage'
}, {
  id: 'ridici-systemy',
  label: 'řídící systémy'
}, {
  id: 'av-distribuce',
  label: 'AV distribuce'
}, {
  id: 'rezervacni-system',
  label: 'rezervační systém'
}, {
  id: 'elektro-silnoproud',
  label: 'elektro silnoproud'
}, {
  id: 'elektro-slaboproud',
  label: 'elektro slaboproud'
}, {
  id: 'prumyslove-rizeni',
  label: 'průmyslové řízení'
}, {
  id: 'fve',
  label: 'FVE'
}];
export function CommercialSolutions() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - 120;
      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    }
  };
  return <section id="komercni" className="w-full bg-white py-12" data-id="element-16">
      <div className="max-w-6xl mx-auto px-6" data-id="element-17">
        {/* Top Overview */}
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.6fr] gap-16 items-start mb-24" data-id="element-18">
          {/* Left Column - Services List */}
          <div className="flex flex-col items-end text-right" data-id="element-19">
            <h2 className="text-2xl font-normal text-[#707070] tracking-wide mb-2" data-id="element-20">
              KOMERČNÍ ŘEŠENÍ
            </h2>
            <p className="text-[#999] font-light mb-8" data-id="element-21">
              Technologie pro váš business
            </p>
            <ul className="space-y-2" data-id="element-22">
              {services.map(service => <li key={service.id} data-id="element-23">
                  <a href={`#${service.id}`} onClick={e => handleScroll(e, service.id)} className="flex items-center justify-end gap-3 text-[#707070] hover:text-[#404040] transition-colors group py-1" data-id="element-24">
                    <span className="text-base" data-id="element-25">{service.label}</span>
                    <img src="https://cdn.magicpatterns.com/uploads/ngsUE6r4TLTc8etnh6qeyU/sipka.png" alt="" className="h-[10px] w-auto opacity-60 group-hover:opacity-100 transition-opacity scale-x-[-1]" data-id="element-26" />
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Right Column - SVG Illustration */}
          <div className="w-full flex items-center justify-center py-8" data-id="element-27">
            <img src="https://cdn.magicpatterns.com/uploads/xfiPLUBWnjtdALuLdefFW3/komerce.svg" alt="Komerční řešení" className="h-52 md:h-[17rem] w-auto object-contain opacity-[0.44]" data-id="element-28" />
          </div>
        </div>

        {/* Detailed Sections */}
        <div className="space-y-16 lg:pl-[100px]" data-id="element-29">
          {/* 1. konferenční technika */}
          <div id="konferencni-technika" className="border-t border-gray-200 pt-16" data-id="element-30">
            <h3 className="text-xl font-normal text-[#707070] tracking-wide uppercase mb-6" data-id="element-31">
              konferenční technika
            </h3>
            <div className="space-y-4 text-[#707070] leading-relaxed" data-id="element-32">
              <p data-id="element-33">
                Co bylo dříve výsadou velkých a bohatých firem, je dnes běžnou
                součástí práce většiny z nás. Přes videokonferenční aplikace se
                dnes prodává, školí, konzultuje, učí, spolupracuje. Je to běžné,
                dostupné, praktické. Pokud i vy potřebujete kvalitní konferenční
                řešení, rádi vám s tím pomůžeme. I když je všude spousta různých
                řešení, přeci jen je důležité umět to správné zvolit (podle
                vašich potřeb a možností), a také správně nainstalovat. Protože
                na detailu, zkušenostech, a správné volbě vždy záleží.
              </p>
              <p data-id="element-34">
                Umíme to se všemi – MS Teams, Zoom, Google, Cisco, BYOD. Pro
                malé, i velké místnosti. Pro jednotlivé místnosti, ale i ty
                spojovací, které fungují právě tak, jak zrovna potřebujete. Pro
                běžné jednací místnosti, ale i ty flexibilní. Pro eventové
                prostory, pro velké prezentace, hybridní spolupráci, školení.
              </p>
              <p data-id="element-35">
                Součástí konferenčních místností musí být nejen vhodně zvolená
                obrazovka, a konferenční platforma / kodek, ale i kvalitní zvuk,
                a také vhodně zvolená kamera. Máme řešení pro více kamer,
                tracking prezentujícího, podle mluvčího, a řešení s více
                kamerami.
              </p>
              <p data-id="element-36">
                Realizovali jsme již více než tisíc jednacích místností, a své
                zkušenosti nabízíme i vám.
              </p>
            </div>
          </div>

          {/* 2. audiovizuální řešení */}
          <div id="audiovizualni-reseni" className="border-t border-gray-200 pt-16" data-id="element-37">
            <h3 className="text-xl font-normal text-[#707070] tracking-wide uppercase mb-6" data-id="element-38">
              audiovizuální řešení
            </h3>
            <div className="space-y-6 text-[#707070] leading-relaxed" data-id="element-39">
              <p data-id="element-40">
                Nejširší část našeho portfolia, protože naše AV řešení lze
                uplatnit v mnoha různých provedeních v nejrůznějších typech
                projektů:
              </p>
              <ul className="space-y-3 pl-[50px]" data-id="element-41">
                {['domácí AV technika', 'smart TV – LCD OLED', '4K projekce i LED obrazovky pro kvalitní filmový zážitek', 'komerční obrazovky', 'profesionální LCD obrazovky pro jednací místnosti, reklamu, retail', 'LED obrazovky pro jednací a prezentační prostory, ale i pro retail, reklamu či expozice', 'unikátní LED maping', 'projekce – konferenční, reklamní, expoziční, videomaping', 'hotelové TV', 'řešení zvuku – mikrofony, ozvučení, přenos', 'podcast, studia pro tvorbu videoobsahů, klíčování, režie, produkce'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-42">
                    <img src="https://cdn.magicpatterns.com/uploads/ngsUE6r4TLTc8etnh6qeyU/sipka.png" alt="" className="h-[10px] w-auto opacity-60 mt-2" data-id="element-43" />
                    <span data-id="element-44">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* 3. digital signage */}
          <div id="digital-signage" className="border-t border-gray-200 pt-16" data-id="element-45">
            <h3 className="text-xl font-normal text-[#707070] tracking-wide uppercase mb-6" data-id="element-46">
              digital signage
            </h3>
            <div className="space-y-4 text-[#707070] leading-relaxed" data-id="element-47">
              <p data-id="element-48">
                Dynamicky se rozvíjející technologie pro tvorbu, správu a
                distribuci audiovizuálního obsahu, především na obrazovkách,
                nacházejí uplatnění v mnoha sférách. Distribuce reklamy v
                retailu, interní komunikace ve firmách, prezentace, expozice,
                nebo třeba výroba. Tam všude lze využít sofistikované systémy
                Digital signage. Vizualizační platforma pro zobrazení,
                interaktivní řešení, SW nástavby, a propojení s dalšími systémy.
              </p>
              <p data-id="element-49">
                Distribuce videoobsahu může být na LCD či LED obrazovkách,
                projekcích, nebo třeba na EPD panelech – bezdrátových
                obrazovkách. Máme řešení, které je robustní, s širokými
                možnostmi, které lze dále rozvíjet, podle vašich potřeb. Máme k
                dispozici vývoj, takže pokud máte nějaké speciální přání, ozvěte
                se.
              </p>
            </div>
          </div>

          {/* 4. řídící systémy */}
          <div id="ridici-systemy" className="border-t border-gray-200 pt-16" data-id="element-50">
            <h3 className="text-xl font-normal text-[#707070] tracking-wide uppercase mb-6" data-id="element-51">
              řídící systémy
            </h3>
            <div className="space-y-4 text-[#707070] leading-relaxed" data-id="element-52">
              <p data-id="element-53">
                Nabízíme celou řadu systému pro snadné a sofistikované ovládání.
                Pro AV projekty používáme především řešení Crestron, které
                nabízí nejen ovládání audiovizuální techniky, ale zároveň umí
                ovládat i domovní technologie, a také se „napojit" na další
                systémy přes různé typy rozhraní a standardů, např. Modbus,
                BACnetIP apod. Řídící systém pomáhá i s automatizací řízení a
                funkcí.
              </p>
              <p data-id="element-54">
                Nabízí také komfortní ovládací rozhraní – dotykové LCD panely se
                zákaznickou grafikou, ovládání přes mobilní zařízení, a další
                možnosti.
              </p>
              <p data-id="element-55">
                Nabízíme také řešení BMS pro řízení budov. Popis je v části
                „průmyslové řízení".
              </p>
            </div>
          </div>

          {/* 5. AV distribuce */}
          <div id="av-distribuce" className="border-t border-gray-200 pt-16" data-id="element-56">
            <h3 className="text-xl font-normal text-[#707070] tracking-wide uppercase mb-6" data-id="element-57">
              AV distribuce
            </h3>
            <div className="space-y-4 text-[#707070] leading-relaxed" data-id="element-58">
              <p data-id="element-59">
                Součástí našich projektů je velmi často také řešení přenosu a
                přepínání signálů AV a USB, a to zpravidla na delší vzdálenost.
                Moderní formáty přinášejí řadu komplikací, a je potřeba systém
                správě navrhnout, aby fungoval stabilně, a zvládal všechna
                zadání. Máme řešení pro kabelové i bezdrátové AV připojení, pro
                přenos mezi dvěma komponenty, nebo přepínání, včetně AV over IP.
                Samostatnou kapitolou je přenos USB, ať už jako AV, nebo KVM.
                Máme řešení pro různé typy aplikací. Navrhované systémy
                testujeme, abychom si ověřili kompatibilitu a spolehlivost.
              </p>
            </div>
          </div>

          {/* 6. rezervační systém */}
          <div id="rezervacni-system" className="border-t border-gray-200 pt-16" data-id="element-60">
            <h3 className="text-xl font-normal text-[#707070] tracking-wide uppercase mb-6" data-id="element-61">
              rezervační systém
            </h3>
            <div className="space-y-4 text-[#707070] leading-relaxed" data-id="element-62">
              <p data-id="element-63">
                Moderní jednací místnosti, jsou potřebné, často dobře vybavené,
                ale někdy nedostupné. Protože nejsou efektivně spravované. Můžou
                být obsazeny opakovanými schůzkami, na které už nikdo nechodí.
                Může si z nich někdo udělat svoji kancelář neoprávněným
                obsazením. Nebo je jednací místnost volná, ale ten kdo ji právě
                potřebuje ji třeba nenajde. Aby se to nedělo, nabízíme řešení
                rezervačního systému, který pomáhá zabránit tomu všemu.
                Přehledný LCD panel u vstupu, čilo obsazenosti v místnosti,
                systém pro správu a jasná pravidla v rámci společnosti. To vše
                pomůže k efektivnímu řízení, přehlednosti, větší využitelnosti.
                A tím šetří starosti, čas a nemalé peníze.
              </p>
            </div>
          </div>

          {/* 7. elektro silnoproud */}
          <div id="elektro-silnoproud" className="border-t border-gray-200 pt-16" data-id="element-64">
            <h3 className="text-xl font-normal text-[#707070] tracking-wide uppercase mb-6" data-id="element-65">
              elektro silnoproud
            </h3>
            <div className="space-y-4 text-[#707070] leading-relaxed" data-id="element-66">
              <p data-id="element-67">
                Realizujeme kompletní řešení elektro silnoproudu do úrovni XY
              </p>
              <p data-id="element-68">
                Návrh a projekt, kabelové rozvody, výroba rozvaděčů a jejich
                instalace a zapojení, kusové zkoušky a revize. Dodáváme a
                instalujeme svítidla, napojujeme spotřebiče.
              </p>
            </div>
          </div>

          {/* 8. elektro slaboproud */}
          <div id="elektro-slaboproud" className="border-t border-gray-200 pt-16" data-id="element-69">
            <h3 className="text-xl font-normal text-[#707070] tracking-wide uppercase mb-6" data-id="element-70">
              elektro slaboproud
            </h3>
            <div className="space-y-6 text-[#707070] leading-relaxed" data-id="element-71">
              <p data-id="element-72">
                Dodáváme slaboproudé systémy pro většinu typů objektů. Nabízíme
                celou řadu řešení a systémů, a umíme využít jejich synergie pro
                zvýšení efektivity, komfortu a výtěžnosti dat.
              </p>
              <ul className="space-y-4 pl-[50px]" data-id="element-73">
                <li className="flex items-start gap-3" data-id="element-74">
                  <img src="https://cdn.magicpatterns.com/uploads/ngsUE6r4TLTc8etnh6qeyU/sipka.png" alt="" className="h-[10px] w-auto opacity-60 mt-2" data-id="element-75" />
                  <span data-id="element-76">
                    <strong data-id="element-77">data</strong> – komplexní řešení – kabelové rozvody
                    – metalické i optické rozvody včetně svařování, RACK,
                    serverovny, aktivní části – switche, wifi AP.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-78">
                  <img src="https://cdn.magicpatterns.com/uploads/ngsUE6r4TLTc8etnh6qeyU/sipka.png" alt="" className="h-[10px] w-auto opacity-60 mt-2" data-id="element-79" />
                  <span data-id="element-80">
                    <strong data-id="element-81">EZS</strong> – zabezpečovací systémy do třídy 3. Od
                    projektu po servis a podporu.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-82">
                  <img src="https://cdn.magicpatterns.com/uploads/ngsUE6r4TLTc8etnh6qeyU/sipka.png" alt="" className="h-[10px] w-auto opacity-60 mt-2" data-id="element-83" />
                  <span data-id="element-84">
                    <strong data-id="element-85">CCTV</strong> – vnitřní i venkovní řešení, ostrovní,
                    náhledové, nebo s využitím AI a pokročilých funkcí pro
                    dohled, sledování osob, signalizace nebezpečí.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-86">
                  <img src="https://cdn.magicpatterns.com/uploads/ngsUE6r4TLTc8etnh6qeyU/sipka.png" alt="" className="h-[10px] w-auto opacity-60 mt-2" data-id="element-87" />
                  <span data-id="element-88">
                    <strong data-id="element-89">přístupový systém</strong> – řešení pro kanceláře,
                    budovy, či instituce. Přístupy přes karty, čipy, biometriku
                    či aplikace (využití NFC). Propojení se zámky dveří,
                    klíčových trezorů, či speciální a zakázkové aplikace
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-90">
                  <img src="https://cdn.magicpatterns.com/uploads/ngsUE6r4TLTc8etnh6qeyU/sipka.png" alt="" className="h-[10px] w-auto opacity-60 mt-2" data-id="element-91" />
                  <span data-id="element-92">
                    <strong data-id="element-93">intercom</strong> – domovní vstupní systémy – audio
                    i video. Pro bytové domy, kancelářské budovy, různé typy
                    provozů. S využitím klasických i IP řešení
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-94">
                  <img src="https://cdn.magicpatterns.com/uploads/ngsUE6r4TLTc8etnh6qeyU/sipka.png" alt="" className="h-[10px] w-auto opacity-60 mt-2" data-id="element-95" />
                  <span data-id="element-96">
                    <strong data-id="element-97">MaR / BMS</strong> – viz. průmyslové řízení
                  </span>
                </li>
              </ul>
            </div>
          </div>

          {/* 9. průmyslové řízení */}
          <div id="prumyslove-rizeni" className="border-t border-gray-200 pt-16" data-id="element-98">
            <h3 className="text-xl font-normal text-[#707070] tracking-wide uppercase mb-6" data-id="element-99">
              průmyslové řízení
            </h3>
            <div className="space-y-4 text-[#707070] leading-relaxed" data-id="element-100">
              <p data-id="element-101">
                Pod tímto pojmem rozumíme řešení pro řízení technologií budov
                (tedy ne v rodinných domech, i když je to často do jisté míry
                podobné), kdy vytváříme buď samotný řídící systém, nebo jeho
                nadstavbu a propojení mezi jednotlivými systémy budovy. V praxi
                je to např. řízení topení, chlazení a vzduchotechniky,
                vizualizace řízení, doplnění o např. měření spotřeby elektrické
                energie, vody a dalších funkcí. Vše zobrazeno na dispečinku, a
                přehled o všech funkcích a spotřebách např. pro vyúčtování.
              </p>
              <p data-id="element-102">
                Navrhneme pro vás to správné řešení řízení, naprojektujeme, a
                pak i dodáme, nainstalujeme a vše nastavíme.
              </p>
            </div>
          </div>

          {/* 10. FVE */}
          <div id="fve" className="border-t border-gray-200 pt-16" data-id="element-103">
            <h3 className="text-xl font-normal text-[#707070] tracking-wide uppercase mb-6" data-id="element-104">
              FVE
            </h3>
            <div className="space-y-4 text-[#707070] leading-relaxed" data-id="element-105">
              <p data-id="element-106">
                Realizujeme kompletní fotovoltaické elektrárny do velikosti XY
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}